import { RefObject, useEffect } from 'react'

export const useOutsideScroll = (ref: RefObject<HTMLElement>, callback: () => void) => {
  useEffect(() => {
    function handleScrollOutside(event: Event) {
      const target = event.target as HTMLElement
      if (ref.current && !ref.current.contains(target) && !target.contains(ref.current)) {
        callback()
      }
    }
    document.addEventListener('scroll', handleScrollOutside, true)
    return () => {
      document.removeEventListener('scroll', handleScrollOutside, true)
    }
  }, [ref, callback])
}
